import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDotBotsAuth } from "@dotbots-boutique/auth-sdk/react";
import { useTranslation } from "react-i18next";
import { Layout } from "./components/Layout";
import { MatchesPage } from "./pages/MatchesPage";
import { TopFourPage } from "./pages/TopFourPage";
import { TeamsPage } from "./pages/TeamsPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { PhotoPage } from "./pages/PhotoPage";
import { WelcomePage } from "./pages/WelcomePage";
import { ConsentPage } from "./pages/ConsentPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ScoringRulesPage } from "./pages/ScoringRulesPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { TermsPage } from "./pages/TermsPage";
import { InviteLandingPage } from "./pages/InviteLandingPage";
import { AdminResultsPage } from "./pages/AdminResultsPage";
import { LeaguesPage } from "./pages/LeaguesPage";
import { LeagueDetailPage } from "./pages/LeagueDetailPage";
import { api } from "./api/client";
function HomeGate({ enrollment }) {
    const { t } = useTranslation();
    if (enrollment.status === "loading")
        return _jsx("p", { children: t("app.loading") });
    if (!enrollment.me.enrolled || !enrollment.me.consentCurrent) {
        return _jsx(Navigate, { to: "/welcome", replace: true });
    }
    return _jsx(Navigate, { to: "/dashboard", replace: true });
}
export function App() {
    const { fetch: authFetch } = useDotBotsAuth();
    const [enrollment, setEnrollment] = useState({ status: "loading" });
    const refresh = useCallback(async () => {
        try {
            const data = await api(authFetch, "/api/me");
            setEnrollment({ status: "ready", me: data });
        }
        catch {
            // If /api/me fails (network, cert), fall back to "not enrolled" so the
            // welcome screen still renders rather than blocking forever.
            setEnrollment({
                status: "ready",
                me: {
                    enrolled: false,
                    consentCurrent: false,
                    currentConsentVersion: "v1-2026-05",
                    photoConsentGranted: false,
                    name: null,
                },
            });
        }
    }, [authFetch]);
    useEffect(() => {
        void refresh();
    }, [refresh]);
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "welcome", element: _jsx(WelcomePage, {}) }), _jsx(Route, { path: "invite/:token", element: _jsx(InviteLandingPage, {}) }), _jsx(Route, { path: "dashboard", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "predictions", element: _jsx(MatchesPage, {}) }), _jsx(Route, { path: "scoreboard", element: _jsx(LeaderboardPage, {}) }), _jsx(Route, { path: "scoring", element: _jsx(ScoringRulesPage, {}) }), _jsx(Route, { path: "photo", element: _jsx(PhotoPage, {}) }), _jsx(Route, { path: "leagues", element: _jsx(LeaguesPage, {}) }), _jsx(Route, { path: "leagues/:id", element: _jsx(LeagueDetailPage, {}) }), _jsx(Route, { path: "admin/results", element: _jsx(AdminResultsPage, {}) }), _jsx(Route, { path: "consent", element: _jsx(ConsentPage, { onDone: refresh }) }), _jsx(Route, { path: "top4", element: _jsx(TopFourPage, {}) }), _jsx(Route, { path: "teams", element: _jsx(TeamsPage, {}) }), _jsx(Route, { path: "privacy", element: _jsx(PrivacyPage, {}) }), _jsx(Route, { path: "terms", element: _jsx(TermsPage, {}) }), _jsxs(Route, { element: _jsx(Layout, { me: enrollment.status === "ready" ? enrollment.me : null }), children: [_jsx(Route, { index: true, element: _jsx(HomeGate, { enrollment: enrollment }) }), _jsx(Route, { path: "matches", element: _jsx(Navigate, { to: "/predictions", replace: true }) }), _jsx(Route, { path: "leaderboard", element: _jsx(Navigate, { to: "/scoreboard", replace: true }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] })] }));
}
